import React from "react";
import { FaUser, FaTimes } from "react-icons/fa";
import { API_BASE_URL } from "../../pages/config";
import { useNavigate } from "react-router-dom";

function Ai2AccountToVironModal({ show, onClose }) {
    const token = localStorage.getItem("token");
    const navigate = useNavigate();

    const handleConfirm = async () => {
        try {
            const res = await fetch(`${API_BASE_URL}/ai2/migrate-user`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },

            });

            const result = await res.json();

            if (res.ok) {
                localStorage.clear();
                onClose();
                alert("User successfully converted to VIRON!");
                navigate('/member/loginPage');
            } else {
                alert(result.message || "Something went wrong!");
            }

        } catch (error) {
            console.error(error);
            alert("API call failed!");
        }
    };

    // Early return if modal is not shown
    if (!show) return null;

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal-container">
                <div className="custom-modal-header">
                    <h2>
                        <FaUser className="modal-icon" /> Confirm Action
                    </h2>
                    <button className="modal-close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="custom-modal-body">
                    <p>
                        Are you sure you want to convert this <strong>AI² account</strong> to a
                        <strong> VIRON account</strong>?
                    </p>
                </div>

                <div className="custom-modal-footer">
                    <button className="primary-btn" onClick={handleConfirm}>
                        Yes
                    </button>
                    <button className="cancel-btn" onClick={onClose}>
                        No
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Ai2AccountToVironModal
